import { MDXRemote, MDXRemoteSerializeResult } from 'next-mdx-remote';

type MarkdownProps = {
  source: MDXRemoteSerializeResult<Record<string, unknown>>;
};

export const MarkdownText = ({ source }: MarkdownProps): JSX.Element => (
  <MDXRemote {...source} />
);

export default MarkdownText;
